<div class="container" (keydown)="keyDownFunction($event)">
    <div class="row">
        <div class="col-24">
            <h1 class="medium">Section 1: Beneficiary Information</h1>
        </div>
    </div>

    <button #focusableEleTop class="focusable-element"></button>
    <div class="row" *ngIf="hasError">
        <div class="col-24">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul>
                    <li *ngFor="let error of ErrorMessages">
                        <button [innerHtml]="error"></button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <p class="required">All fields are required, unless marked as optional.</p>
        </div>
    </div>
    <div class="row" *ngIf="isEnroller">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Agent ID'"
                                    [text]="agentUserName"
                                    (onValueChange)="agentUserName = $event">
                </ValidatedTextField>
            </div>
        </div>
    </div>
    <div>
        <!--<div class="row">
            <div class="col-16">
                <p class="blue-text bottom-20">Let’s go ahead and start your enrollment today in SilverScript (PDP).</p>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <fieldset class="radio">
                    <legend class="blue-text">To take your application over the phone, Medicare requires us to record this conversation. May we record the conversation?</legend>
                    <ValidatedRadioButtonGroup [options]="rblrecord"
                                               [selectedValue]="enrollment.RBLRECORD"
                                               (onValueChange)="SelectRblrecordOptions($event)"
                                               [radioGroupName]="'rblrecord'">
                    </ValidatedRadioButtonGroup>
                </fieldset>
            </div>
        </div>
        <div *ngIf="!rblrecordyes">
            <div class="row">
                <div class="col-16">
                    <p class="blue-text">I’m sorry, but I’m not permitted to assist with your enrollment by phone unless it is recorded. As an alternative, if you desire to enroll with SilverScript, I can send you a paper enrollment form to complete and mail back, or you may enroll online at <a class="link" href="https://www.silverscript.com" target="_blank">www.silverscript.com</a></p>
                </div>
                </div>
            <div class="row" *ngIf="showQtip">
                <div class="col-16">

                    <p class="qtip-note">

                        <strong> Note:</strong> : If caller declines recording of the call and has elected to receive a paper enrollment form, proceed to <u>“Section 2. Beneficiary Information”</u> and input the enrollee’s name and mailing address.
                        <a (click)="BenfDetails()" class="link"> Click here</a>
                    </p>
                    <p class="qtip-note"><strong>Note:</strong> If caller does not agree to recording of the conversation, does not request a paper enrollment and does not want to enroll at <a class="link" href="https://www.silverscript.com" target="_blank">www.silverscript.com</a>, proceed to <u>“Section 6. Enrollment End”</u> and disposition as Ineligible – Declined Recorded Conversation. <a (click)="SalesBenfDetails()" class="link"> Click here</a></p>
            </div>
        </div>
        </div>-->
        <div>
            <div class="row" *ngIf="false">
                <div class="col-16">
                    <fieldset class="radio">
                        <legend class="blue-text">Let us go ahead and start your enrollment.</legend>
                        <legend class="blue-text">
                            I am acting on behalf of Aetna and may be compensated based on {{this.spnYourTheir}} enrollment in a plan.
                            <br /><br />Will you be the beneficiary?
                        </legend>
                        <ValidatedRadioButtonGroup [options]="rblBenfe"
                                                   [selectedValue]="enrollment.RBLBENFE"
                                                   (onValueChange)="SelectRblrblBenfeOptions($event)"
                                                   [radioGroupName]="'rblBenfe'">
                        </ValidatedRadioButtonGroup>
                    </fieldset>
                </div>
            </div>

            <div class="row">

                <div class="col-16">
                    <p class="blue-text" *ngIf="ShowCurrentYearScript">
                        May I please have {{spnIsBeneficiaryYour}} first name, middle initial, last name, suffix, date of birth, gender, phone number, permanent address and email address?
                    </p>
                    <p class="blue-text" *ngIf="!ShowCurrentYearScript">
                        May I please have {{spnIsBeneficiaryYour}} first name, middle initial, last name, as it appears on their Medicare card, suffix, date of birth, gender, phone number, permanent address and email address?
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="input-wrapper">
                        <ValidatedTextField label="First Name"
                                            [text]="enrollment.APPFN"
                                            (onValueChange)="enrollment.APPFN = $event"
                                            [validators]="[]"
                                            [disabled]="disabled">
                        </ValidatedTextField>
                    </div>
                </div>
                <div class="col-4">
                    <div class="input-wrapper">
                        <ValidatedTextField label="Middle Initial (optional)"
                                            [text]="enrollment.APPMI"
                                            [maxlength]="1"
                                            (onValueChange)="enrollment.APPMI = $event"
                                            [validators]="[]"
                                            [disabled]="disabled">
                        </ValidatedTextField>
                    </div>
                </div>
                <div class="col-6">
                    <div class="input-wrapper">
                        <ValidatedTextField label="Last Name"
                                            [text]="enrollment.APPLN"
                                            (onValueChange)="enrollment.APPLN = $event"
                                            [validators]="[]"
                                            [disabled]="disabled">
                        </ValidatedTextField>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-5">
                    <div class="input-wrapper">
                        <ValidatedTextField class="wide"
                                            label="Suffix (optional)"
                                            [text]="enrollment.SUFFIX"
                                            (onValueChange)="enrollment.SUFFIX = $event"
                                            [validators]="[]"
                                            [disabled]="disabled">
                        </ValidatedTextField>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <!--<label>Date of Birth (mm/dd/yyyy):</label>-->
                        <!--<JQDatePicker [selectedDate]="enrollmentViewModel.APPDOB"
                                        (elementClicked)="enrollmentViewModel.APPDOB = $event">
                        </JQDatePicker>-->
                        <ValidatedDateTextField label="Date of Birth"
                                                id="DOB"
                                                [date]="enrollment.APPDOB"
                                                (onDateChange)="enrollment.APPDOB = $event"
                                                [validators]="[validatedDate,notBlankValidator]"
                                                [disabled]="disabled">
                        </ValidatedDateTextField>
                    </div>
                </div>
                <div class="col-8">
                    <fieldset class="radio">
                        <legend>Gender</legend>
                        <ValidatedRadioButtonGroup [options]="genderOptions"
                                                   [selectedValue]="enrollment.APPGEN"
                                                   [radioGroupName]="'genderOptions'"
                                                   (onValueChange)="SelectGender($event)"
                                                   [disabled]="disabled">
                        </ValidatedRadioButtonGroup>
                    </fieldset>
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <MaskedValidatedTextField class="field" [label]="'Phone Number (optional)'" id="authrep-phone" [text]="enrollment.APPPHONE"
                                                  (onValueChange)="enrollment.APPPHONE = $event"
                                                  [maxlength]="10" [inputMask]="phoneNumberInputMask">
                        </MaskedValidatedTextField>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="'Address 1'"
                                            [text]="enrollment.APPADD1"
                                            [validators]="[]"
                                            (blur)="onBlur()"
                                            [disabled]="disabled"
                                            (onValueChange)="enrollment.APPADD1 = $event" maxlength="40">
                        </ValidatedTextField>
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="'Address 2 (optional)'"
                                            [text]="enrollment.APPADD2"
                                            (blur)="onBlur()"
                                            [disabled]="disabled"
                                            (onValueChange)="enrollment.APPADD2= $event" maxlength="40">
                        </ValidatedTextField>
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedCheckbox class="centered-checkbox"
                                           [id]="'po-box'"
                                           [label]="'P.O. Box Override'"
                                           [checked]="enrollment.POBOX"
                                           (onValueChange)="enrollment.POBOX= $event">
                        </ValidatedCheckbox>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="'City'"
                                            [text]="enrollment.APPCITY"
                                            [validators]="[]"
                                            (blur)="onBlur()"
                                            [disabled]="disabled"
                                            (onValueChange)="enrollment.APPCITY= $event"
                                            maxlength="40">
                        </ValidatedTextField>
                    </div>
                </div>
                <div class="col-5">
                    <div class="input-wrapper">
                        <ValidatedDropDown class="wide"
                                           [selectedValue]="enrollment.APPST"
                                           [label]="'State'"
                                           [disabled]="disabled"
                                           (onValueChange)="SelectState($event)"
                                           [options]="states"
                                           (blur)="onBlur()">
                        </ValidatedDropDown>
                    </div>
                </div>
                <div class="col-3">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="'ZipCode'"
                                            [text]="enrollment.APPZIP"
                                            [validators]="[]"
                                            (blur)="onBlur()"
                                            [disabled]="disabled"
                                            (onValueChange)="enrollment.APPZIP = $event"
                                            maxlength="5">
                        </ValidatedTextField>
                    </div>
                </div>

            </div>

            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField class=""
                                            [label]="'Email Address (optional):'"
                                            id="EmailAddress"
                                            [text]="enrollment.APPEMAIL"
                                            (onValueChange)="enrollment.APPEMAIL = $event">

                        </ValidatedTextField>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="row">
                <div class="col-16">
                    <fieldset class="radio">
                        <legend class="blue-text" *ngIf="ShowCurrentYearScript">
                            Thank you for expressing an interest in enrolling in a prescription drug plan offered by Aetna. My name is {{agentFullname}} I am a licensed agent with CVS Health, a parent company of SilverScript and Aetna.<br /><br />
                            What plan do {{this.spnyouthey}} {{this.spnIsBeneficiary2}} want to enroll in? <br /><br />
                            The premium for {{this.enrollment.PLANTYPENAME}} will be ${{planvalue}}.
                        </legend>
                        <legend class="blue-text" *ngIf="!ShowCurrentYearScript">
                            Thank you for expressing an interest in enrolling in a prescription drug plan offered by Aetna. My name is {{agentFullname}} I am a licensed agent with CVS Health, the parent company of SilverScript and Aetna.<br /><br />
                            What plan do {{this.spnyouthey}} want to enroll in? <br /><br />
                            The premium for {{this.enrollment.PLANTYPENAME}} will be ${{planvalue}}.
                        </legend>
                        <ValidatedRadioButtonGroup [label]="'Desired Plan'"
                                                   [options]="optionrbPlan"
                                                   [selectedValue]="enrollment.PLANTYPE"
                                                   (onValueChange)="onPlanChange($event)"
                                                   [radioGroupName]="'Plan'">
                        </ValidatedRadioButtonGroup>

                    </fieldset>
                    <p class="blue-text">
                        Before we begin the enrollment process, I want to confirm that {{this.spnyoubenef}} understand that you will be submitting an application for enrollment into {{this.enrollment.PLANTYPENAME}}.  At the end of this process, we will submit {{this.spnYourTheir}} enrollment request to the Centers for Medicare & Medicaid Services, known as CMS, for enrollment into the plan. CMS is the federal agency that runs the Medicare program.
                        <br /><br />
                        <span>{{this.spnyouthey | titlecase}}</span>
                        can usually only enroll into or disenroll from a Medicare plan from October 15 through December 7. However, there are special exceptions. An example is if someone has gained or lost Medicare and Medicaid.
                    </p>
                </div>
            </div>
            <div class="row" *ngIf="UILangEng">
                <div class="col-16">
                    <fieldset class="radio">
                        <legend class="blue-text">
                            In addition, you understand and agree this conversation will be recorded.
                            <br />
                            <br />
                            Do you want to continue?
                        </legend>
                        <ValidatedRadioButtonGroup [options]="rblrecord"
                                                   [selectedValue]="enrollment.RBLRECORD"
                                                   (onValueChange)="SelectRblrecordOptions($event)"
                                                   [radioGroupName]="'rblrecord'">
                        </ValidatedRadioButtonGroup>

                    </fieldset>
                </div>
            </div>

            <div *ngIf="!rblrecordyes">
                <div class="row">
                    <div class="col-16" *ngIf="showQtip && !ShowCurrentYearScript">
                        <p class="qtip-note"><strong>qTip Note:</strong>If caller says no</p>
                    </div>
                    <div class="col-16">
                        <p class="blue-text">Please know that we record all telephonic enrollment requests. We are unable to continue with this enrollment unless you agree to be recorded.</p>
                    </div>
                    <div class="col-16" *ngIf="showQtip">
                        <p class="qtip-note" *ngIf="ShowCurrentYearScript"><strong>qTip Note:</strong>If person still says no, proceed to <u>“Section 7, G2 - Enrollment End”</u> <a (click)="BenfDetails()" class="link">Click here</a></p>
                        <p class="qtip-note" *ngIf="!ShowCurrentYearScript"><strong>qTip Note:</strong>If person still says no, proceed to <u>“Section 7. Enrollment End”</u> <a (click)="BenfDetails()" class="link">Click here</a></p>
                    </div>
                </div>
                <div class="row" *ngIf="showQtip">
                    <div class="col-16">
                        <div *ngIf="checkPlanyear">
                            <p class="qtip-note"><strong>qTip Note:</strong> If caller elects to receive a paper enrollment form, select <u>HICN hyperlink</u> to verify information in MARx, then input the enrollee’s mailing address in <u>“Section 2. Beneficiary Information”</u> and proceed to <u>“Section 6. Enrollment End”</u>. Disposition as Requested Paper Enrollment Form. <a (click)="BenfDetails()" class="link">Click here</a></p>
                            <p class="qtip-note">
                                <strong>qTip Note:</strong> :  If caller declines recording of the call and has elected to receive a paper enrollment form, proceed to <u>“Section 2. Beneficiary Information”</u> and input the enrollee’s name and mailing address.
                                <a (click)="BenfDetails()" class="link"> Click here</a>
                            </p>
                            <p class="qtip-note"><strong>qTip Note:</strong> If caller does not agree to recording of the conversation, does not request a paper enrollment and does not want to enroll at <a class="link" href="https://www.silverscript.com" target="_blank">www.silverscript.com</a>, proceed to <u>“Section 7. Enrollment End”</u> and disposition as Ineligible – Declined Recorded Conversation. <a (click)="SalesBenfDetails()" class="link"> Click here</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="!rblrecordno">
            <!--<div class="row" *ngIf="ShowCurrentYearScript">
                <div class="col-16">
                    <fieldset class="radio">
                        <legend class="blue-text" *ngIf="ShowCurrentYearScript">Let’s go ahead and start your enrollment.<br /><br /> Before we begin, may I ask if an Insurance Agent or Sales Representative is currently present with you?</legend>
                        <ValidatedRadioButtonGroup [options]="rblRep"
                                                   [selectedValue]="enrollment.RBLREP"
                                                   (onValueChange)="SelectRblrecordNoOptions($event)"
                                                   [radioGroupName]="'rblRep'">
                        </ValidatedRadioButtonGroup>
                    </fieldset>
                </div>
                <div class="col-16" *ngIf="!rblrepno">
                    <p class="blue-text">
                        Unfortunately, I’m unable to complete your enrollment today
                        over the phone in the  presence of an Insurance Agent or Sales Representative. Please call us back when the Agent or Sales Representative is no longer present or you can enroll yourself online at <a class="link" href="https://www.silverscript.com" target="_blank">SilverScript.com</a>.
                    </p>
                    <div class="centerAnswer">
                        <div class="Vdntooltip" *ngIf="isQtip">
                            <p class="qtip-note">
                                <strong>qTip Note:</strong> Answer questions pertaining to why the agent/representative cannot be present during enrollment as applicable, then proceed to  <u>“Section 7. Enrollment End”.</u>  <a (click)="SalesBenfDetails()" class="link">Click here</a><br />
                            </p>
                        </div>
                    </div>
                </div>
            </div>-->
            <div *ngIf="!rblrepyes">
                <div class="row">
                    <div class="col-16">
                        <fieldset class="radio">
                            <legend class="blue-text">Let us go ahead and start your enrollment.</legend>

                            <legend class="blue-text" *ngIf="ShowCurrentYearScript">
                                I am acting on behalf of Aetna and may be compensated based on {{this.spnyourhisher}} enrollment in a plan.
                                <br /><br />Will you be the beneficiary?
                            </legend>
                            <legend class="blue-text" *ngIf="!ShowCurrentYearScript">
                                I am acting on behalf of Aetna and may be compensated based on {{this.spnYourTheir}} enrollment in a plan.
                                <br /><br />Will you be the beneficiary?
                            </legend>
                            <ValidatedRadioButtonGroup [options]="rblBenfe"
                                                       [selectedValue]="enrollment.RBLBENFE"
                                                       (onValueChange)="SelectRblrblBenfeOptions($event)"
                                                       [radioGroupName]="'rblBenfe'">
                            </ValidatedRadioButtonGroup>
                        </fieldset>
                    </div>
                </div>
                <div *ngIf="!rblbenfeyes">
                    <div class="row">
                        <div class="col-16">
                            <fieldset class="radio">
                                <legend class="blue-text">
                                    As you are calling on behalf of the beneficiary; Medicare requires us to certify two things.<br /><br />
                                    1. One, you are authorized to act on behalf of the Medicare beneficiary under state/law.<br />
                                    2. And Two, you will be able to provide documentation of this authority if Medicare asks for it. <br /><br />
                                    Do you certify to these two things?<br />
                                </legend>
                                <ValidatedRadioButtonGroup [options]="rblBenfereply"
                                                           [selectedValue]="enrollment.RBLBENFEREPLY"
                                                           (onValueChange)="SelectRblrblBenfeReplyOptions($event)"
                                                           [radioGroupName]="'rblBenfereply'">
                                </ValidatedRadioButtonGroup>
                            </fieldset>
                        </div>
                    </div>

                    <div *ngIf="!rblbenfereplyno">
                        <div class="row" *ngIf="showQtip">
                            <div class="col-16">
                                <p class="qtip-note bottom-20"><strong>qTip Note:</strong> If caller CAN certify to above 2 conditions, the information capture is REQUIRED for an authorized representative.</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-16">
                                <p class="blue-text">May I please have your: </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <ValidatedTextField [label]="'Legally Authorized Representative Name'"
                                                        [text]="enrollment.AUTHREPNAME"
                                                        [maxlength]="100"
                                                        (onValueChange)="enrollment.AUTHREPNAME = $event"
                                                        [validators]="[]">
                                    </ValidatedTextField>
                                </div>
                            </div>
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <MaskedValidatedTextField [label]="'Phone Number'"
                                                              [maxlength]="10"
                                                              [text]="enrollment.AUTHREPPHONE"
                                                              [inputMask]="phoneNumberInputMask"
                                                              (onValueChange)="enrollment.AUTHREPPHONE = $event"
                                                              [validators]="[]">
                                    </MaskedValidatedTextField>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <ValidatedTextField [label]="'Address Line1'"
                                                        [text]="enrollment.AUTHREPADD1"
                                                        [maxlength]="100"
                                                        (onValueChange)="enrollment.AUTHREPADD1 = $event"
                                                        [validators]="[]">
                                    </ValidatedTextField>
                                </div>
                            </div>
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <ValidatedTextField [label]="'Address Line2 (optional)'"
                                                        [text]="enrollment.AUTHREPADD2"
                                                        [maxlength]="100"
                                                        (onValueChange)="enrollment.AUTHREPADD2 = $event">

                                    </ValidatedTextField>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <ValidatedTextField [label]="'City'"
                                                        [text]="enrollment.AUTHREPCITY"
                                                        [maxlength]="50"
                                                        (onValueChange)="enrollment.AUTHREPCITY = $event"
                                                        [validators]="[]">
                                    </ValidatedTextField>
                                </div>
                            </div>
                            <div class="col-5">
                                <div class="input-wrapper">
                                    <ValidatedDropDown class="wide"
                                                       [selectedValue]="enrollment.AUTHREPST"
                                                       [label]="'State'"
                                                       [disabled]="'false'"
                                                       (onValueChange)="enrollment.AUTHREPST  = $event"
                                                       [options]="authrepstates">
                                    </ValidatedDropDown>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="input-wrapper">
                                    <ValidatedTextField [label]="'Zip Code'"
                                                        [maxlength]="5"
                                                        [text]="enrollment.AUTHREPZIP"
                                                        (onValueChange)="enrollment.AUTHREPZIP = $event"
                                                        [validators]="[]">
                                    </ValidatedTextField>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <ValidatedDropDown class="wide"
                                                       [label]="'Relationship to Enrollee'"
                                                       [disabled]="'false'"
                                                       [selectedValue]="enrollment.AUTHREPREL"
                                                       (onValueChange)="enrollment.AUTHREPREL =$event"
                                                       [options]="rblRelation">
                                    </ValidatedDropDown>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <ValidatedTextField [label]="'Email Address (optional)'"
                                                        [maxlength]="60"
                                                        [text]="enrollment.AUTHREPEMAIL "
                                                        (onValueChange)="enrollment.AUTHREPEMAIL  = $event">
                                    </ValidatedTextField>
                                </div>
                            </div>
                            <!--<div class="col-8">
                                <div class="input-wrapper">
                                    <ValidatedDropDown class="wide"
                                                       [label]="'Receive Duplicate Copy of Plan Materials'"
                                                       [options]="ddllMailCopy"
                                                       [selectedValue]="enrollment.AUTHREPCOPYIND"
                                                       (onValueChange)="enrollment.AUTHREPCOPYIND =$event">
                                    </ValidatedDropDown>
                                </div>
                            </div>-->
                        </div>


                        <div class="row" *ngIf="showQtip">
                            <div class="col-16">
                                <p class="qtip-note bottom-20"><strong>qTip Note:</strong> If legally authorized representative requests to receive a duplicate copy of plan materials in the mail, it will be generated through above collection of their mail address and selecting the “YES” response, otherwise select No.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--Individual start-->
            <div *ngIf="visibleFrom2025 && isVisibleIndiv">
                <div class="row">
                    <div class="col-16">
                        <div class="bottom-20">

                            <label class="blue-text">
                                Does the Applicant have an individual(i.e. agents, brokers, SHIP counselors, family members, or other third parties) helping somone fill out this form (but not authorized to make decisions on behalf of the enrollee)?
                            </label>

                            <ValidatedRadioButtonGroup [label]="''"
                                                       [options]="rblAppIndIND"
                                                       [selectedValue]="enrollment.INDREPIND"
                                                       (onValueChange)="rblAppIndINDClick($event)"
                                                       [radioGroupName]="'rblAppIndIND'">
                            </ValidatedRadioButtonGroup>
                        </div>
                    </div>
                </div>
                <div *ngIf="isAppInd">
                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField [label]="'Name'"
                                                    [text]="enrollment.INDREPNAME"
                                                    (onValueChange)="enrollment.INDREPNAME = $event"
                                                    [validators]="[notBlankValidator]">
                                </ValidatedTextField>
                            </div>
                        </div>

                        <div class="col-6">
                            <div class="input-wrapper">
                                <ValidatedDropDown class="wide"
                                                   [label]="'Relationship to enrollee'"
                                                   [disabled]="'false'"
                                                   [selectedValue]="enrollment.RELTOENROLL"
                                                   (onValueChange)="relToEnrollonValueChange($event)"
                                                   [options]="rblReltoEnroll">
                                </ValidatedDropDown>
                            </div>
                        </div>

                    </div>

                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper" *ngIf="isNPNmandatory">
                                <ValidatedTextField [label]="'NPN'"
                                                    [text]="enrollment.NPN"
                                                    [maxlength]="10"
                                                    (onValueChange)="enrollment.NPN = $event"
                                                    [validators]="[notBlankValidator]">
                                </ValidatedTextField>
                            </div>
                            <div class="input-wrapper" *ngIf="!isNPNmandatory">
                                <ValidatedTextField [label]="'NPN (optional)'"
                                                    [text]="enrollment.NPN"
                                                    [maxlength]="10"
                                                    (onValueChange)="enrollment.NPN = $event">
                                </ValidatedTextField>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        
        <!--Individual End-->

        <div class="row" *ngIf="isMyAplgy">
            <div class="col-16">
                <p class="blue-text"> My apologies, I can only take an enrollment from the Medicare beneficiary or from someone who is authorized to act on behalf of the Medicare beneficiary.</p>
            </div>
        </div>

        <div *ngIf="!rblbenfInfo || isAppInd">
            <div class="row">
                <div class="col-16">
                    <p class="blue-text" *ngIf="ShowCurrentYearScript">
                        If the permanent address provided is a P.O. Box, request an address other than a P.O. Box. If the enrollee does not have this address or is unable to provide another address, inform them that by not providing a valid permanent address, enrollment into the plan could be delayed or at risk of denial.
                    </p>
                    <p class="blue-text" *ngIf="!ShowCurrentYearScript">
                        If the permanent address provided is a P.O. Box, request an address other than a P.O. Box. If the enrollee does not have this address or is unable to provide another address, inform them that by not providing a valid permanent address, enrollment into the plan could be delayed or at risk of denial.
                        <br /><br />
                        <span class="homelessness">&#123;<b>Agent Note-For individuals experiencing homelessness:</b> if they want to join a plan but have no permanent residence, a Post Office Box, an address of a shelter or clinic, or the address where they receive mail (for example, social security checks) may be considered their permanent residence address.&#125;</span>
                    </p>
                    <p class="qtip-note bottom-20" *ngIf="showQtip"><strong>qTip Note:</strong> Enter email address while verifying verbally:</p>
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField class=""
                                            [label]="'Email Address'"
                                            id="EmailAddress"
                                            [text]="enrollment.APPEMAIL"
                                            (onValueChange)="enrollment.APPEMAIL = $event">

                        </ValidatedTextField>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-16">
                    <p class="blue-text" *ngIf="ShowCurrentYearScript">
                        By providing us with {{this.spnyourhisher}} email address, {{this.spnyouthey}} agree{{this.spnIsReside}} to receive email communications from Aetna until {{this.spnyouthey}} opt(s) out of further emails. {{this.spnyouthey | titlecase}} have the opportunity to opt-out at any time.
                    </p>
                    <p class="blue-text" *ngIf="!ShowCurrentYearScript">
                        By providing us with {{this.spnYourTheir}} email address, {{this.spnyouthey}} agree{{this.spnIsReside}} to receive email communications from Aetna until {{this.spnyouthey}} opt(s) out of further emails. {{this.spnyouthey | titlecase}} have the opportunity to opt-out at any time.
                    </p>
                </div>
            </div>

            <!--<div class="col-16" *ngIf="ShowCurrentYearScript">
                <p class="blue-text"> If the permanent address provided is a P.O. Box, request an address other than a P.O. Box. If the enrollee does not have this address or is unable to provide another address, inform them that by not providing a valid permanent address, enrollment into the plan could be delayed or at risk of denial.</p>
                <p class="qtip-note bottom-20" *ngIf="showQtip"><strong>qTip Note:</strong> Enter email address while verifying verbally:</p>
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField class=""
                                            [label]="'Email Address'"
                                            id="EmailAddress"
                                            [text]="enrollment.APPEMAIL"
                                            (onValueChange)="enrollment.APPEMAIL = $event">

                        </ValidatedTextField>
                    </div>
                </div>
                    <p class="blue-text">
                        By providing us with {{this.spnyourhisher}} email address, {{this.spnyouheshe}} agree{{this.spnIsReside}} to receive email communications from SilverScript until {{this.spnyouheshe}} opt(s) out of further emails. {{this.spnYouheshe | titlecase}} {{this.spnHasHave}} the opportunity to opt-out at any time.
                    </p>
                </div>
            </div>-->
            <!--<fieldset class="radio" *ngIf="IsRbllongtermYes">
                <legend class="blue-text bottom-10 limit-width">May I please have the Institution name and phone number?</legend>
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper">
                            <ValidatedTextField label="Institution Name"
                                                [maxlength]="50"
                                                [text]="enrollmentViewModel.LTCFACILITY"
                                                (onValueChange)="enrollmentViewModel.LTCFACILITY= $event"
                                                [disabled]="disabled">
                            </ValidatedTextField>
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="input-wrapper">
                            <ValidatedTextField label="Phone Number (numbers only)"
                                                [maxlength]="10"
                                                [text]="enrollmentViewModel.LTCPHONE"
                                                (onValueChange)="enrollmentViewModel.LTCPHONE= $event"
                                                [validators]="[]"
                                                [disabled]="disabled">
                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
            </fieldset>-->
            <fieldset>
                <legend class="blue-text limit-width">Is {{this.spnYourTheir}} mailing address the same as {{this.spnYourTheir}} permanent address?</legend>
                <div class="row">
                    <div class="col-24">
                        <!--<input type="checkbox"
                                class="option__input"
                                id="same-as-business-address"
                                [checked]="sameAsBusinessAddress"
                                (click)="clickOnSameAsBusinessAddress()" />
                        <label for="same-as-business-address">  Mailing Address is the same as Permanent Address </label>-->
                        <div class="bottom-20">
                            <ValidatedCheckbox [id]="'same-as-business-address'"
                                               [label]="'Mailing Address is the same as Permanent Address'"
                                               [checked]="enrollment.ISSAMEADDRESS"
                                               (onValueChange)="clickOnSameAsBusinessAddress($event)">
                            </ValidatedCheckbox>
                        </div>
                    </div>
                </div>
                <div *ngIf="IsSameAddress">
                    <fieldset>
                        <legend class="blue-text bottom-10 limit-width"> May I please have the mailing address?</legend>
                    </fieldset>

                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField [label]="'Address 1'"
                                                    [text]="enrollment.MAILADD1"
                                                    [validators]="[]"
                                                    [disabled]="disabled"
                                                    (onValueChange)="enrollment.MAILADD1= $event" maxlength="40">
                                </ValidatedTextField>
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField [label]="'Address 2 '"
                                                    [text]="enrollment.MAILADD2"
                                                    [disabled]="disabled"
                                                    (onValueChange)="enrollment.MAILADD2= $event" maxlength="40">
                                </ValidatedTextField>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField [label]="'City'"
                                                    [text]="enrollment.MAILCITY"
                                                    [validators]="[]"
                                                    [disabled]="disabled"
                                                    (onValueChange)="enrollment.MAILCITY = $event" maxlength="40">
                                </ValidatedTextField>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="input-wrapper">
                                <ValidatedDropDown class="wide"
                                                   [selectedValue]="enrollment.MAILST"
                                                   [label]="'State'"
                                                   [disabled]="disabled"
                                                   (onValueChange)="enrollment.MAILST = $event"
                                                   [options]="mailingstates">
                                </ValidatedDropDown>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="input-wrapper">
                                <ValidatedTextField [label]="'Zip'"
                                                    [text]="enrollment.MAILZIP"
                                                    [validators]="[]"
                                                    [disabled]="disabled"
                                                    (onValueChange)="enrollment.MAILZIP = $event" maxlength="5">
                                </ValidatedTextField>
                            </div>
                        </div>
                    </div>
                    <!--<div class="row">
                                        <div class="col-16" *ngIf="ShowCurrentYearScript">
                                            <p class="qtip-note bottom-20"><strong>qTip Note:</strong> If paper enrollment has been requested, proceed to <u>“Section 7. Enrollment End”</u>. <a (click)="SalesBenfDetails()"><strong> Click here</strong></a></p>
                                        </div>

                    </div>-->
                    <!--<div class="row" *ngIf="isQtip">
                    <div class="col-16" *ngIf="!ShowCurrentYearScript">
                        <div class="col-16" *ngIf="checkPlanyear">
                            <p class="qtip-note"><strong>qTip Note:</strong> If paper enrollment has been requested, proceed to  <u>“Section 7. Enrollment End”</u>. <a (click)="SalesBenfDetails()"><strong> Click here</strong></a></p>
                        </div>
                    </div>-->
                </div>
            </fieldset>

            <div class="row">

                <raceethnicity [enrollmentRaceEthnicityViewModel]="enrollment"></raceethnicity>
            </div>
            <div class="row" *ngIf="visibleFrom2025">
                <div class="col-22">
                    <genderPref [enrollmentgenderPrefyViewModel]="enrollment"></genderPref>
                </div>
            </div>
        </div>
        <!--End  Beneficairy Info-->
        <div class="row" *ngIf="!rblbenfeno || isAppInd">
            <div class="col-24">
                <button class="button primary" (click)="formSubmit()">Continue</button>
            </div>
        </div>
    </div>
</div>
</div>
